import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyHap({}) {
  return (
    <NtCaseStudySectionContainer
      style={styles.container}
      title={
        "Case Study: NT Maritime's Partnership with Princess Lodges and Westmark Hotels to Transform Communication Solutions in Alaska"
      }
      image={require("../../../assets/images/partners/logo-holland-america-group-new.png")}
      imageStyle={{ width: 130, height: 130 }}
    >
      <NtCaseStudyText>
        <NtCaseStudyTextBold>Background:</NtCaseStudyTextBold>
        {"\n\n"}NT Maritime, a wholly owned subsidiary of NT Connect, is
        renowned for delivering innovative communication solutions to the
        maritime industry, particularly on ships with challenging connectivity
        requirements. Leveraging its experience at sea, NT Maritime partnered
        with Princess Lodges (a division of Princess Cruises) and Westmark
        Hotels (a subsidiary of Holland America Line) to elevate communication
        technologies across 9 Alaska based hotels. This collaboration aimed to
        provide an enhanced, unified communication experience for both guests
        and hotel staff.{"\n\n"}
        <NtCaseStudyTextBold>Challenge:</NtCaseStudyTextBold>
        {"\n\n"}Alaska presents unique challenges for communications
        infrastructure, including remote locations and demanding winter
        conditions that can hinder reliable connectivity. Princess Lodges and
        Westmark Hotels required a solution to revamp their outdated PBX systems
        and to offer a seamless communication experience across properties. With
        over 4,000 extensions spread across guest rooms and more than 20 office
        locations in Alaska and Canada, NT Maritime needed to develop a
        scalable, reliable, and user-friendly system that would improve guest
        satisfaction and streamline hotel operations.{"\n\n"}{" "}
        <NtCaseStudyTextBold>Solution:</NtCaseStudyTextBold>
        {"\n\n"}NT Maritime introduced a next-generation communication solution
        comprising on-premise and cloud-based systems. This robust setup unified
        all properties within a single communications platform that integrates
        seamlessly with mobile and desktop devices. Key components of the
        implementation included:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          In-room Communication Upgrades:
        </NtCaseStudyTextBold>{" "}
        Guests now enjoy enhanced options for communication within their rooms.
        New features allow them to schedule housekeeping visits, order room
        service, and set alerts to be notified when the Northern Lights are
        visible—allowing for a memorable Alaskan experience from their hotel
        balconies.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Mobile Communication Tools for Staff:
        </NtCaseStudyTextBold>{" "}
        Hotel staff gained access to a dedicated mobile application that
        provides high-quality voice communication, comprehensive chat messaging,
        and management tools. This streamlined internal communication among all
        staff across hotels, transportation hubs, and data centers, improving
        operational efficiency and guest service response times.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Unified Communication Platform:
        </NtCaseStudyTextBold>{" "}
        The solution supports over 4,000 extensions, allowing guests and staff
        to connect smoothly across the properties. This platform not only
        enhances in-room and staff communications but also improves the
        reliability of the system in remote areas, ensuring that connectivity is
        sustained despite Alaska’s challenging environment.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 40 }}>
        <NtCaseStudyTextBold>Implementation Process</NtCaseStudyTextBold>
        {"\n\n"}NT Maritime's experience in managing complex communications
        systems at sea equipped it to deliver a seamless implementation across
        the properties in Alaska. The company worked closely with the hotel
        chains to adapt the communication Private & Confidential technology used
        on ships to the land-based hospitality setting, with modifications to
        suit the specific needs of Alaska based hotels.{"\n\n"}{" "}
        <NtCaseStudyTextBold>Results</NtCaseStudyTextBold>
        {"\n\n"}The unified communication system has had significant positive
        impacts, including:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }} number={"1."}>
        <NtCaseStudyTextBold>Improved Guest Experience:</NtCaseStudyTextBold>{" "}
        Guests now have direct access to hotel services through their room
        communication systems, enhancing convenience and personalizing their
        stay. The added Northern Lights alert feature has been a unique
        value-add that contributes to a memorable guest experience.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }} number={"2."}>
        <NtCaseStudyTextBold>Operational Efficiency:</NtCaseStudyTextBold> The
        mobile app for staff has streamlined internal communication, resulting
        in quicker response times and better coordination among teams across the
        properties. Staff can now handle guest requests more effectively,
        creating a more seamless experience.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }} number={"3."}>
        <NtCaseStudyTextBold>
          Enhanced Reliability in Challenging Conditions:
        </NtCaseStudyTextBold>{" "}
        NT Maritime’s technology, proven in difficult connectivity settings at
        sea, has been instrumental in maintaining reliable communications during
        Alaska’s harsh winter season, ensuring continuity and reliability.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 40 }}>
        <NtCaseStudyTextBold>Statement</NtCaseStudyTextBold>
        {"\n\n"}Garry Paxinos, CTO & CAIO of NT Maritime, highlighted the
        importance of NT Maritime’s experience in creating solutions for
        challenging environments:
      </NtCaseStudyText>

      <NtCaseStudyText
        style={{
          marginTop: 20,
          paddingLeft: 30,
          paddingRight: 30,
          fontStyle: "italic",
        }}
      >
        “In light of the demanding Alaskan winter conditions, it became evident
        that our technology, combined with our expertise in implementing
        communication solutions in challenging connectivity Private &
        Confidential settings on cruise ships and now hotels, made us the
        optimal choice for this deployment in Alaska.”
      </NtCaseStudyText>

      <NtCaseStudyText style={{ marginTop: 40 }}>
        <NtCaseStudyTextBold>Conclusion</NtCaseStudyTextBold>
        {"\n\n"}The partnership between NT Maritime, Princess Lodges, and
        Westmark Hotels exemplifies how industry expertise can be adapted to
        meet unique geographic and operational challenges. By unifying and
        modernizing the communication systems across their Alaskan properties,
        NT Maritime has provided a reliable, scalable solution that benefits
        both guests and hotel staff. This case demonstrates NT Maritime’s
        capability to tailor its maritime communications expertise for the
        land-based hospitality industry, creating new standards in guest
        services and operational efficiency.
      </NtCaseStudyText>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyHap;
